'use strict';

(function () {
  'use strict';

  angular.module('msCore').controller('ErrorPageCtrl', ErrorPageCtrl);

  ErrorPageCtrl.$inject = ['$stateParams'];

  function ErrorPageCtrl($stateParams) {
    var vm = this;
    vm.message = $stateParams.message;
    vm.errorCode = $stateParams.errorCode;
    vm.contact = $stateParams.contact;
  }
})();